import { render, staticRenderFns } from "./DeleteLocationModal.vue?vue&type=template&id=2d5b6219&scoped=true&"
import script from "./DeleteLocationModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteLocationModal.vue?vue&type=script&lang=ts&"
import style0 from "./DeleteLocationModal.vue?vue&type=style&index=0&id=2d5b6219&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d5b6219",
  null
  
)

export default component.exports